/* global cURL */
export class ThemeFilter {
  #debounceTimer;
  #type;

  constructor() {
    const container = document.querySelector('.filters');
    if (!container) return;

    this.#type = container.dataset.type;
    if (!this.#type || this.#type !== 'news-item') return;

    const filterOptions = container.querySelectorAll('[data-filter]');
    if (filterOptions.length === 0) return;

    this.#bindEvents(filterOptions);
    this.#processFilterUpdate();
  }

  #checkFilters(activeFilterIDs) {
    document.querySelectorAll(`.${this.#type}`).forEach(item => {
      if (activeFilterIDs.length === 0) item.classList.remove(`${this.#type}--inactive`);
      else {
        const linkedIdsString = item.dataset.linkedIds;
        if (!linkedIdsString) item.classList.add(`${this.#type}--inactive`);
        else {
          const linkedIds = linkedIdsString.split(';').map(id => Number(id));
          if (activeFilterIDs.some(activeFilterID => linkedIds.includes(activeFilterID)))
            item.classList.remove(`${this.#type}--inactive`);
          else
            item.classList.add(`${this.#type}--inactive`);
        }
      }
    });
  }

  #processFilterUpdate = async () => {
    const activeCheckboxes = document.querySelectorAll('[name="filter"]:checked');
    const activeFilterIDs = [...activeCheckboxes].map(checkbox => Number(checkbox.value));

    const params = {
      type: this.#type,
      ids: activeFilterIDs.join(',')
    };
    const requestBody =
      Object.entries(params).map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');

    try {
      const response = await fetch(`${cURL}mwork/ajax/set-filters.jsp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: requestBody
      });
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }
    }
    catch (error) {
      console.error(`Failed to change filters (${this.#type})`, error);
    }

    this.#checkFilters(activeFilterIDs);
  };

  #handleFilterOption = async e => {
    if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
      const filter = e.currentTarget.dataset.filter;
      if (filter === 'clear')
        document.querySelectorAll('[name="filter"]:checked').forEach(el => { el.checked = false; });

      clearTimeout(this.#debounceTimer);
      this.#debounceTimer = setTimeout(() => {
        this.#processFilterUpdate();
      }, 250);
    }
  };

  #bindEvents(filterOptions) {
    filterOptions.forEach(el => {
      el.addEventListener('click', this.#handleFilterOption);
      el.addEventListener('keydown', this.#handleFilterOption);
    });
  }
}
